<div
  class="content-card"
  [ngClass]="item.bundle">
  <div
    class="content-card__image"
    [placeholderImage]="!item.mediaImage && item.bundle"
    [class.default]="!item.mediaImage"
    [cropImage]="item.mediaImage | preSignedUrl | async"
    [crop]="item.mediaImage?.crop"
    [additionalOptions]="{ aspect_ratio: '16:9' }">
  </div>

  <div class="content-card__info">
    <div class="content-bundle-time">
      <span class="content-card-label">
        <lib-icon [icon]="item.bundle | entityBundleIcon" [size]="16"></lib-icon>
        {{ item | bundleLabel | async }}
      </span>

      @if (item.time) {
        <span class="content-time">
          <lib-icon icon="clock" [size]="16"></lib-icon>
          {{ item.time | minutesToTime : 'short' }}
        </span>
      }

      <ng-content select="[card-header]"></ng-content>
    </div>

    <div class="content-card-title">{{ item?.title }}</div>

    <ng-content select="[card-footer]"></ng-content>
  </div>

</div>
